import React from 'react';
import styled from 'styled-components';
import { Poppins } from 'src/common/Poppins';

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const Rule = styled.div`
  flex: 1;
  height: 1px;
  background: ${({ theme }) => theme.colors.stroke};
`;

export const SectionHeader: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <Row>
    <Poppins px={16} weight={600} color="cflowerBlue" css="text-transform: uppercase; white-space: nowrap;">
      {children}
    </Poppins>
    <Rule />
  </Row>
);
